"use client";

import { DetailsStemSplit } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/DetailsStemSplit";
import { StemSplitGroupWithAudioNoDates } from "@/types/defs/stemSplit";

export function Details({
  stemSplitGroup,
}: {
  stemSplitGroup: StemSplitGroupWithAudioNoDates;
}) {
  return (
    <ul className="ml-4 mt-6 flex flex-col gap-3">
      {stemSplitGroup.stemSplits.map((stemSplit) => (
        <DetailsStemSplit key={stemSplit.id} stemSplit={stemSplit} />
      ))}
    </ul>
  );
}
